import { useLang } from "@/context";
import { Reveal } from "./Reveal";

export const HowItWorks = () => {
    const { t } = useLang();
    return (
        <section id="how-it-works" data-testid="how-it-works-section" className="py-20 sm:py-28 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl">
                    <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#8D1717]">{t.nav.howItWorks}</p>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#2A0505] mt-3">{t.how.heading}</h2>
                    <p className="text-base sm:text-lg text-[#6B5B57] mt-4">{t.how.sub}</p>
                </Reveal>

                <div className="grid md:grid-cols-3 gap-5 mt-12">
                    {t.how.steps.map((step, i) => (
                        <Reveal key={step.title} delay={i * 0.12}>
                            <div data-testid={`how-step-${i + 1}`} className="relative h-full rounded-3xl border border-[#EADFD8] bg-[#FBF7F3] p-8 overflow-hidden hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300">
                                <span className="font-display italic font-black text-[5.5rem] leading-none text-[#8D1717]/10 absolute -top-3 right-4 select-none">
                                    0{i + 1}
                                </span>
                                <span className="font-display font-black text-[#8D1717] text-lg">0{i + 1}</span>
                                <h3 className="font-display text-xl sm:text-2xl font-bold text-[#2A0505] mt-3 leading-snug">{step.title}</h3>
                                <p className="text-sm sm:text-base text-[#6B5B57] mt-3 leading-relaxed">{step.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
